var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChefioIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-22.66 -23.18 64 64",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#435363"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.465 23.23c-7.946 0-14.412-6.465-14.412-14.4S1.52-5.594 9.465-5.594c6.56 0 12.106 4.406 13.844 10.413h5.576c-1.856-9.022-9.857-15.827-19.42-15.827-10.932 0-19.826 8.894-19.826 19.827s8.894 19.826 19.826 19.826c9.563 0 17.564-6.803 19.42-15.826H23.3c-1.738 6.006-7.284 10.4-13.844 10.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.25 18.534a13.7 13.7 0 0 0 9.716 4.03V16.82a7.98 7.98 0 0 1-5.657-2.344z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-4.28 8.82c0 1.967.42 3.838 1.166 5.532l5.256-2.312a7.96 7.96 0 0 1-.677-3.22 8 8 0 0 1 8-8v-5.746C1.885-4.927-4.28 1.24-4.28 8.82",
    fill: "#f38b00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.448-4l-2.085 5.357a8.02 8.02 0 0 1 4.027 3.452h6.224C21.386.784 18.348-2.468 14.448-4",
    fill: "#435363"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.366 16.27l2.083 5.357a13.81 13.81 0 0 0 8.167-8.81h-6.224c-.906 1.565-2.325 2.8-4.027 3.453",
    fill: "#f38b00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-15.966 16.508l-.258-.908-.015-.056-.208-.85-.038-.175-.153-.738-.058-.33-.1-.593-.07-.5a26.45 26.45 0 0 1-.24-3.53h-5.43a31.96 31.96 0 0 0 .233 3.853l.01.082.143 1.03.047.284.15.84.1.443.144.665.143.58.132.517.274.965h.002c.375 1.24.82 2.45 1.335 3.62l4.975-2.188c-.428-.97-.798-1.975-1.1-3.004z",
    fill: "#435363"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.465 35.392c-7.326 0-13.967-2.983-18.778-7.795l-3.845 3.845C-7.367 37.234.63 40.82 9.465 40.82c16.318 0 29.78-12.215 31.75-28h-5.478C33.8 25.58 22.757 35.392 9.465 35.392m0-53.145a26.42 26.42 0 0 1 15.885 5.286l3.252-4.36A31.85 31.85 0 0 0 9.465-23.18c-13.578 0-25.18 8.458-29.826 20.393l5.064 1.97C-11.432-10.72-1.8-17.753 9.465-17.753",
    fill: "#f38b00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.737 4.82h5.478a31.79 31.79 0 0 0-4.602-12.944L32-5.246A26.4 26.4 0 0 1 35.737 4.82",
    fill: "#435363"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.565 4.82h5.497c-1.434-9.217-7.747-16.838-16.205-20.14l-1.963 5.048c6.432 2.5 11.298 8.178 12.67 15.092",
    fill: "#f38b00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.465-11.674v-5.413c-10.973 0-20.372 6.857-24.142 16.512l5.044 1.963C-6.65-6.25.786-11.674 9.465-11.674",
    fill: "#435363"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-11.027 8.82h-5.413c0 10.886 6.75 20.22 16.286 24.047l2-5.024C-5.687 24.814-11.027 17.43-11.027 8.82",
    fill: "#f38b00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.465 29.3v5.414c12.925 0 23.668-9.515 25.597-21.907h-5.498C27.7 22.2 19.397 29.3 9.465 29.3",
    fill: "#435363"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChefioIcon);
export default __webpack_public_path__ + "static/media/chefio-icon.a0799972f666cd0b156ecddb11b789a1.svg";
export { ForwardRef as ReactComponent };